function openPopUp({ url, target, onCallBack }) {
  const height = 400;
  const width = 700;
  const left = (window.document.body.clientWidth - width) / 2;
  const top = (window.document.body.clientHeight - height) / 2;

  const openedWindow = window.open(
    url,
    target,
    'resizable = yes, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left
  );

  const openedWindowTracker = setInterval(() => {
    try {
      if (openedWindow.location.origin === window.location.origin) {
        openedWindow.close();
        window.clearInterval(openedWindowTracker);
        window.focus();
        onCallBack?.();
      }
    } catch {
      // cross origin
    }
  }, 1000);
}

export { openPopUp };
